import React from "react";
import { Fade } from "react-awesome-reveal";
import { IRoomBannerData } from "../../exports/interfaces";

const RoomBanner = (props: { roomBanner: IRoomBannerData[] }) => {
  return (
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-1455370 elementor-section-stretched elementor-section-height-min-height elementor-section-full_width elementor-section-height-default elementor-section-items-middle custom-elementor-element-1455370"
        data-id="1455370"
        data-element_type="section"
        data-settings='{"stretch_section":"section-stretched","background_background":"classNameic","hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
        style={{
          backgroundImage: props?.roomBanner[0]?.image[0]?.media?.name
            ? `url(${process.env.REACT_APP_cmsUrl}/uploads/${props?.roomBanner[0]?.image[0]?.media?.name})`
            : "url(https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png)",
        }}
      >
        {/* <div className="elementor-background-overlay"></div> */}
        <div className="elementor-container elementor-column-gap-default">
          <div
            className="custom-aboutus-gradient"
            style={{ height: "700px" }}
          ></div>
          <div className="elementor-row" style={{ zIndex: 1 }}>
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f011a00"
              data-id="f011a00"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap custom-elementor-title">
                  <Fade cascade damping={0.2} direction="up" triggerOnce={true}>
                    <div
                      className="elementor-element elementor-element-f0e1a3c elementor-invisible elementor-widget elementor-widget-heading"
                      data-id="f0e1a3c"
                      data-element_type="widget"
                      data-settings='{"_animation":"fadeInUp","hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h1 className="elementor-heading-title elementor-size-default">
                          {props?.roomBanner[0]?.title}
                        </h1>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-a29b869 elementor-invisible elementor-widget elementor-widget-heading"
                      data-id="a29b869"
                      data-element_type="widget"
                      data-settings='{"_animation":"fadeInUp","_animation_delay":400,"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h5 className="elementor-heading-title elementor-size-default">
                          {props?.roomBanner[0]?.description}
                        </h5>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RoomBanner;
